import * as Comlink from 'comlink';
import { useEffect, useState } from 'react';
import clock from 'worker/clock';

export const useClock = () => {
    const [datetime, setDatetime] = useState(new Date());
    useEffect(() => {
        void clock.subscribe(Comlink.proxy(setDatetime));
    }, []);
    return datetime;
};
